import { useContext } from 'react';

import { AlertBannerContext } from '../providers/AlertBannerProvider';

export function useAlertBanner() {
    const context = useContext(AlertBannerContext);

    if (context === undefined || context === null) {
        throw new Error('useAlertBanner must be used within a AlertBannerProvider');
    }

    return context;
}
